/**
 * Session Storage key used to save current user's ninetailed experiment data. Once Braze is
 * ready to start logging custom events we will read this information and send it.
 */
export const ninetailedExperimentsDataKey = 'ninetailed_experiments_data'
